import React from 'react';
import {TituloMenu, DivFlexbox} from '../clientes/style'
import {Row, Col, Card} from 'antd'
const Manuales = () => {
    return (
        <>
           <TituloMenu>Manuales</TituloMenu> 
           <Row type="flex" align="middle" justify="center">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <Card title="Manuales"  >
                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/bBTo3ZORMjQ?rel=0" allow="autoplay; encrypted-media" title="Descargar" ></iframe>
                            <div>
                                <h3 >Descargar App</h3>
                                <p >El video esta dirigido a vendedores, los cuales deberan hacer uso de la aplicación.</p>
                            </div>
                        </DivFlexbox>
                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/t5gR790IM90?rel=0" allow="autoplay; encrypted-media" title="Crear Ordenes" ></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Crear Ordenes y uso de aplicación <strong>Vendedores</strong> </h3>
                                <p className="card-text">Los Usuarios vendedores podran utilizar la aplicación para gestionar ordenes.</p>
                            </div>
                        </DivFlexbox>
                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/EfacN6m0qNs?rel=0" allow="autoplay; encrypted-media"  title="Flujo"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Flujo Completo de cada proceso</h3>
                                <p className="card-text">En el video se muestra el flujo de comunicacion en el sistema por cada departamento.</p>
                            </div>
                        </DivFlexbox>

                        <DivFlexbox>
                            <iframe className="card-img-top" width="560" height="315" src="https://www.youtube.com/embed/KpZJY3On5-I?rel=0" allow="autoplay; encrypted-media" title="Validar Ordenes" ></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Validar Ordenes</h3>
                                <p className="card-text">El validador coteja en el portal bancario de Nacional Ferretera de Hidalgo que todos los pagos anticipados esten efectuados.</p>
                            </div>
                        </DivFlexbox>

                        <DivFlexbox>
                            <iframe className="card-img-top" width="560" height="315" src="https://www.youtube.com/embed/aEU6DbS_hyg?rel=0" allow="autoplay; encrypted-media" title="Surtir Mercancia"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Surtir Mercancia</h3>
                                <p className="card-text">El usuario encargado de generar el embarque, debe cambiar el de las ordenes aprobadas.</p>
                            </div>
                        </DivFlexbox>

                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/Y5ya5g13BqY?rel=0" allow="autoplay; encrypted-media" title="Aprobar Orden"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Aprobar una Orden</h3>
                                <p className="card-text">El administrador de sistema, tiene el rol de aprobar la orden.</p>
                            </div>
                        </DivFlexbox>
                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/XzV1tHMTX3I?rel=0"  allow="autoplay; encrypted-media" title="Gestionar Clientes"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Gestionar Clientes Cajeros.</h3>
                                <p className="card-text">Los usuarios cajeros podran gestionar los clientes.</p>
                            </div>
                        </DivFlexbox>

                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/_4xEixjcSww?rel=0" allow="autoplay; encrypted-media" title="Panel Administrador"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Panel de usuario administrador</h3>
                                <p className="card-text">El administrador de sistema, puede operar acciones importantes como lo son: Aprobar ordenes, gestionar clientes y registrar usuarios nuevos en el sistema.</p>
                            </div>
                        </DivFlexbox>

                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/EF2GgV0xkGk?rel=0"  allow="autoplay; encrypted-media" title="Surbir catalogo"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Subir Productos al Catalogo</h3>
                                <p className="card-text">El administrador del sistema, puede  cargar los productos al catalogo y podra administrar cada uno de los productos que estan vigentes.</p>
                            </div>
                        </DivFlexbox>
                        <DivFlexbox>
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/NJBBq_DwzeA?rel=0" allow="autoplay; encrypted-media" title="Panel de mercancia"></iframe>
                            <div className="card-body">
                                <h3 className="card-title">Panel de Superusuario administrador general</h3>
                                <p className="card-text">El superusuario de sistema, puede operar acciones importantes importar tarifas,importar clientes y en general puede modificar los apectos indispensables del sistema.</p>
                            </div>
                        </DivFlexbox>
                    </Card>
                    
                </Col>
           </Row>
    
        </>
    );
};

export default Manuales;